var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x84\xBC\xEC\x84\x9C/\xEB\xB0\xA7\xEB\x8D\xB0\xEB\xA6\xAC"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2020_17997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2020_17997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "battery_charging_80",
    d: "M6.95451 19C6.74103 19 6.56214 18.9133 6.41784 18.74C6.27339 18.5668 6.20117 18.3522 6.20117 18.096V4.64425C6.20117 4.38808 6.27339 4.17342 6.41784 4.00025C6.56214 3.82708 6.74103 3.7405 6.95451 3.7405H8.46076V2.904C8.46076 2.64783 8.53298 2.43317 8.67742 2.26C8.82173 2.08667 9.00062 2 9.21409 2H10.7845C10.998 2 11.1769 2.08667 11.3212 2.26C11.4656 2.43317 11.5378 2.64783 11.5378 2.904V3.7405H13.0458C13.2594 3.7405 13.438 3.82708 13.5818 4.00025C13.7255 4.17342 13.7974 4.38808 13.7974 4.64425V9.01725C13.7974 9.17975 13.7512 9.32008 13.6587 9.43825C13.5663 9.55642 13.4517 9.63217 13.3149 9.6655C12.7691 9.77433 12.2621 9.97942 11.7941 10.2808C11.3262 10.5821 10.9115 10.9616 10.5501 11.4192C10.1369 11.9422 9.80832 12.5487 9.5643 13.2385C9.32013 13.9282 9.19805 14.6724 9.19805 15.4712C9.19805 15.9094 9.23596 16.333 9.3118 16.742C9.38763 17.1508 9.50138 17.5452 9.65305 17.925C9.74819 18.1827 9.74152 18.4263 9.63305 18.6558C9.52457 18.8853 9.36298 19 9.14825 19H6.95451ZM7.45117 8.6155H12.5474V5.23075H7.45117V8.6155ZM13.7814 16.423H12.7783C12.6328 16.423 12.5246 16.3468 12.4537 16.1943C12.3826 16.0418 12.3876 15.8886 12.4689 15.7348L14.2087 12.4365C14.2667 12.3442 14.3383 12.3115 14.4233 12.3385C14.5081 12.3653 14.5505 12.4398 14.5505 12.562V14.577H15.5537C15.6991 14.577 15.8073 14.6532 15.8783 14.8057C15.9494 14.9582 15.9443 15.1114 15.863 15.2653L14.1233 18.5635C14.0652 18.6558 13.9937 18.6885 13.9087 18.6615C13.8238 18.6347 13.7814 18.5602 13.7814 18.438V16.423Z",
    fill: "#161C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon_battery.4c528456c1357e71a3f8dee840a35c22.svg";
export { ForwardRef as ReactComponent };